import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Activity, PhoneIncoming, PhoneOutgoing, Globe, Clock } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const Stat = ({ icon: Icon, label, value, testid }) => (
  <div className="flex items-center gap-1.5 text-xs text-gray-400" data-testid={testid}>
    <Icon size={13} className="text-gray-500" />{label}<span className="text-white font-medium tabular-nums">{value}</span>
  </div>
);

export const LiveCallsCard = ({ workspaceId }) => {
  const { api } = useAuth();
  const [d, setD] = useState(null);

  useEffect(() => {
    let alive = true;
    const tick = () => api.get(`/api/workspaces/${workspaceId}/concurrency`).then(r => alive && setD(r.data)).catch(() => {});
    tick();
    const id = setInterval(tick, 10000);
    return () => { alive = false; clearInterval(id); };
  }, [api, workspaceId]);

  if (!d) return null;
  const pct = Math.min(100, Math.round((d.live.total / Math.max(1, d.limit)) * 100));
  const bar = d.at_limit ? 'bg-rose-400' : pct >= 80 ? 'bg-amber-400' : 'bg-teal-400';
  return (
    <div className="glass-card rounded-xl p-5 mb-6" data-testid="live-calls-card">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <span className="relative flex h-2.5 w-2.5">
            {d.live.total > 0 && <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-60" />}
            <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${d.live.total > 0 ? 'bg-teal-400' : 'bg-gray-600'}`} />
          </span>
          <div>
            <p className="text-[10px] uppercase tracking-[0.18em] text-gray-500 font-semibold">Live calls · all sub-accounts</p>
            <p className="text-2xl font-semibold text-white tabular-nums" data-testid="live-calls-count">
              {d.live.total}<span className="text-gray-500 text-lg"> / {d.limit}</span>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4 flex-wrap">
          <Stat icon={PhoneIncoming} label="Inbound" value={d.live.inbound} testid="live-calls-inbound" />
          <Stat icon={PhoneOutgoing} label="Outbound" value={d.live.outbound} testid="live-calls-outbound" />
          <Stat icon={Globe} label="Web" value={d.live.web} testid="live-calls-web" />
          {d.queued > 0 && <Stat icon={Clock} label="Queued" value={d.queued} testid="live-calls-queued" />}
          <Link to={`/workspace/${workspaceId}/billing#call-lines`} className="text-xs text-teal-300 hover:text-teal-200 flex items-center gap-1" data-testid="live-calls-add-lines">
            <Activity size={13} /> Add lines
          </Link>
        </div>
      </div>
      <div className="mt-4 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
        <div className={`h-full ${bar} transition-[width] duration-700`} style={{ width: `${pct}%` }} data-testid="live-calls-bar" />
      </div>
    </div>
  );
};

export default LiveCallsCard;
